import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataserviceService } from '../dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-onboarding-actions-management',
  templateUrl: './onboarding-actions-management.component.html',
  styleUrl: './onboarding-actions-management.component.css'
})

export class OnboardingActionsManagementComponent {

  actionItems: any[] = [];
  buckets: any[] = [];

  loading: boolean = false;
  actionsModal: boolean = false;
  modalLoading: boolean = false;

  actionsForm: FormGroup;

  constructor(
    private data: DataserviceService,
    private message: NzMessageService
  ) {

    this.actionsForm = new FormGroup({
      id: new FormControl(null),
      name: new FormControl(null, [Validators.required]),
      description: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      bucket: new FormControl(null, [Validators.required]),
      type: new FormControl(null, [Validators.required]),
      status: new FormControl(null)
    })

  }

  ngOnInit() {
    this.getActions();
    this.getBuckets();
  }

  getActions() {
    this.loading = true;
    this.data.getData('actions/company-actions')
      .subscribe({
        next: (response: any) => {
          this.actionItems = response.data  
          this.loading = false;
;
        },
        error: (error: any) => {
          console.log('error: ', error)
          this.loading = false;
          this.message.error('Failed to get actions');
        }
      })
  }

  getBuckets() {
    this.data.getData('onboarding/buckets')
      .subscribe({
        next: (response: any) => {
          this.buckets = response
        },
        error: (error: any) => {
          console.log('error: ', error)
          this.message.error('Failed to get buckets');
        }
      })
  }

  openCreateModal() {
    this.actionsModal = true;
  }

  handleOk() {
    if(this.actionsForm.valid) {
      if(this.actionsForm?.get('id')?.value) {
        this.updateAction();
      }else {
        this.createAction();
      }
    }else {
      alert('Please make sure the form is filled out correctly!')
    }
  }

  createAction() {
    this.modalLoading = true;
    this.data.postData(this.actionsForm.value, 'actions/create')
      .subscribe({
        next: (response: any) => {  
          if(response?.result === 'success') {
            this.actionsModal = false;
            this.actionsForm.reset();
            this.getActions();
            this.message.success('Action created successfully'); 
          }else {
            this.message.error('Failed to create action');
          }
          this.modalLoading = false;
        },
        error: (error: any) => {
          this.modalLoading = false;
          console.log('error: ', error)
          this.message.error('Failed to create action');
        }
      })
  }

  updateAction() {
    this.modalLoading = true;
    this.data.postData(this.actionsForm.value, 'actions/update')
      .subscribe({
        next: (response: any) => {  
          if(response?.result === 'success') {
            this.actionsModal = false;
            this.actionsForm.reset();
            this.message.success('Action updated successfully');
            this.getActions();
          }else {
            this.message.error('Failed to update action');
          }
          this.modalLoading = false;
        },
        error: (error: any) => {
          this.modalLoading = false;
          console.log('error: ', error)
          this.message.error('Failed to update action');
        }
      })
  }

  handleCancel() {
    this.actionsForm.reset();
    this.actionsModal = false;
  }

  openEditModal(action: any) {
    this.actionsModal = true;
    this.actionsForm.patchValue({
      id: action.id,
      name: action.name,
      description: action.description,
      bucket: action.bucket_id,
      type: action.who_takes_action,
      status: action.status
    })

  }


}
